module.exports = __webpack_public_path__ + "img/more-vertical.cb5a271a.svg";